<template>
  <div class="shared-profile-avatar-wrapper">
    <v-avatar color="#e0e0e0" size="60" @click="$emit('click')">
      <div class="profile-avatar-initials" v-if="userName !== 'Add New'">
        {{ initialsFromUsername() }}
      </div>
      <v-icon v-else color="#bdbdbd" dense> mdi-plus-thick </v-icon>
    </v-avatar>
    <div class="user-wrapper">
      <div class="user-profile-container" @click="$emit('click')">
        {{ captalizedUserName(userName) }}
      </div>
      <div class="user-profile-container" v-if="email" @click="$emit('click')">{{ email }}</div>
      <div style="display: flex" @click="$emit('click')">
        <div class="user-profile-container" v-if="shareStatus">
          {{ shareStatus }}
        </div>
        <div class="user-profile-container" v-if="shareExpireDate">
          &nbsp;- Exp. {{ shareExpireDate }}
        </div>
      </div>
      <div style="display: flex; margin-top: 10px">
        <div class="view-container" @click="$emit('btnLeftClick')">View</div>
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from '../utils/helpers'

export default {
  name: 'shared-profile-avatar',
  props: {
    userName: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    shareStatus: {
      type: String,
      default: ''
    },
    shareExpireDate: {
      type: String,
      default: ''
    }
  },
  methods: {
    captalizedUserName(st) {
      return Helpers.capitalizedText(st)
    },
    initialsFromUsername() {
      const fullName = this.userName.split(' ')
      if (fullName.length > 1) {
        const initials = fullName.shift().charAt(0) + fullName.pop().charAt(0)
        return initials.toUpperCase()
      } else if (fullName[0].length > 1) {
        const initials = fullName[0].substring(0, 2)
        return initials.toUpperCase()
      } else {
        return this.userName.toUpperCase()
      }
    }
  }
}
</script>

<style>
.shared-profile-avatar-wrapper {
  /*margin: 10px;*/
  display: flex;
  flex-direction: row;
  padding: 10px;
  margin: 5px 0;
  border-radius: 5px;
  background-color: white;
  box-shadow: 0px 0px 8px rgba(60, 60, 60, 0.25);
}

.profile-avatar-initials {
  color: #bdbdbd;
  font-weight: 700;
  font-size: 16px;
  font-style: normal;
}

.user-profile-container {
  color: #202124;
  font-size: 14px;
  letter-spacing: 0.3px;
  margin-top: 2px;
}

.user-wrapper {
  margin: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  cursor: pointer;
}

.view-container {
  color: #047be3;
  cursor: pointer;
  font-size: 15px;
  margin-right: 10px;
}

.remove-container {
  color: #999999;
  cursor: pointer;
  font-size: 15px;
  margin-left: 10px;
}
</style>
